import axios from 'axios'
const seo_dictionary = require('../../public/static/json/seo_dictionary.json')

export default {
    getDictionaryDataByRouteName(name) {
        return seo_dictionary[name]
    }
}